
  document.addEventListener("DOMContentLoaded", function () {
    const contentDiv = document.querySelector(".articleLookbook-des");
    if (!contentDiv) return;

    const fullText = contentDiv.innerHTML;

    // Optional: how many characters/paragraphs to show before truncating
    const paragraphs = contentDiv.querySelectorAll("p");
    const truncateAfter = 2;

    if (paragraphs.length <= truncateAfter) return; // No need for read more

    // Get the first N paragraphs only
    let visibleContent = "";
    for (let i = 0; i < truncateAfter; i++) {
      visibleContent += paragraphs[i].outerHTML;
    }

    // Hide full content initially
    contentDiv.innerHTML = `
      <div class="short-description">${visibleContent}</div>
      <div class="full-description" style="display: none;">${fullText}</div>
      <button class="toggle-description-btn" style="margin-top:10px; background:#232323; color:#fff; border:none; padding:8px 16px; cursor:pointer; font-size:14px; border-radius:4px;">Read More</button>
    `;

    const btn = contentDiv.querySelector(".toggle-description-btn");
    const shortDesc = contentDiv.querySelector(".short-description");
    const fullDesc = contentDiv.querySelector(".full-description");

    btn.addEventListener("click", function () {
      const isExpanded = fullDesc.style.display === "block";

      fullDesc.style.display = isExpanded ? "none" : "block";
      shortDesc.style.display = isExpanded ? "block" : "none";
      btn.textContent = isExpanded ? "Read More" : "Read Less";
    });
  });

